'use client';

interface DetailsArbreErrorProps {
  message?: string;
}

export function DetailsArbreError({ message = 'Aucune étape trouvée.' }: DetailsArbreErrorProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background antialiased" role="alert">
      <div className="text-center space-y-3">
        <h1 className="text-2xl font-semibold text-foreground sm:text-3xl">Erreur</h1>
        <p className="text-base font-medium text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

